export const localStorageKeys = {
  selectedSubaccount: 'selectedSubaccount',
  pendingSubaccount: 'pendingSubaccount',
  productLeverage: 'productLeverage',
  hidePnl: 'hidePnl',
  walletData: 'wallet-data',
  favorites: 'favorites',
  defaultFavoritesInitialized: 'defaultFavoritesInitialized',
  termsAgreedAtByAccount: 'termsAgreedAtByAccount',
  dismissMobileWarning: 'dismissMobileWarning',
  showConfirmOrderModal: 'showConfirmOrderModal',
  showConfirmCloseModal: 'showConfirmCloseModal',
  showConfirmCloseAllModal: 'showConfirmCloseAllModal',
  showConfirmCancelAllModal: 'showConfirmCancelAllModal',
  showTradeHistory: 'showTradeHistory',
  showLiquidationPrice: 'showLiquidationPrice',
  showPositionsInformation: 'showPositionsInformation',
  showOrderInformation: 'showOrderInformation',
  showFills: 'showFills',
  orderbookSetSizeOnClick: 'orderbookSetSizeOnClick',
  tradeFormStore: 'tradeFormStore',
  chartResolution: 'chartResolution',
  starredChartResolutions: 'starredChartResolutions',
  chartType: 'chartType',
  starredChartTypes: 'starredChartTypes',
  fundingDisplayMode: 'fundingDisplayMode',
  chartDisplayPrice: 'chartDisplayPrice',
  hotBarAutoScrollPaused: 'hotBarAutoScrollPaused',
  // TradingView storage keys
  tvCharts: 'TV_charts',
  tvStudyTemplates: 'TV_studyTemplates',
  tvDrawingTemplates: 'TV_drawingTemplates',
  tvChartTemplates: 'TV_chartTemplates',
  tvDrawings: 'TV_drawings',
} as const;
